import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginWithPassword,sendOtp, verifyOtp } from '../../../queries/userlogin';

export default function AuthComponent() {
  const [step, setStep] = useState('choice'); // 'choice' | 'password' | 'otp'
  const [number, setNumber] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [deviceId] = useState('device-xyz'); // Replace or generate securely
  const navigate = useNavigate();

  const containerStyle = {
    maxWidth: '400px',
    margin: '50px auto',
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    fontFamily: 'Arial, sans-serif',
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    margin: '8px 0',
    borderRadius: '4px',
    border: '1px solid #999',
    fontSize: '16px',
  };

  const buttonStyle = {
    width: '100%',
    padding: '10px',
    margin: '8px 0',
    backgroundColor: '#007BFF',
    color: '#fff',
    fontSize: '16px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  };

  const handlePasswordLogin = async () => {
    try {
      const { data } = await loginWithPassword({ number, password });
      if (data.success) {
        localStorage.setItem('_USER_TOKEN_', data.token);
        window.location.href = '/user/profile';
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert('Login failed');
    }
  };

  const handleSendOtp = async () => {
    try {
      const { data } = await sendOtp({ number });
      if (data.success) {
        setStep('otp');
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert('Failed to send OTP');
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const { data } = await verifyOtp({ number, otp });
      if (data.success) {
        localStorage.setItem('_USER_TOKEN_', data.token);
        window.location.href = '/user/profile';
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert('OTP verification failed');
    }
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center' }}>User Login</h2>

      {step === 'choice' && (
        <>
          <input
            type="text"
            placeholder="Phone number"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            style={inputStyle}
          />
          <button onClick={() => setStep('password')} style={buttonStyle}>
            Login with Password
          </button>
          <button onClick={handleSendOtp} style={buttonStyle}>
            Send OTP
          </button>
        </>
      )}

      {step === 'password' && (
        <>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
          />
          <button onClick={handlePasswordLogin} style={buttonStyle}>
            Submit
          </button>
        </>
      )}

      {step === 'otp' && (
        <>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            style={inputStyle}
          />
          <button onClick={handleVerifyOtp} style={buttonStyle}>
            Verify OTP
          </button>
        </>
      )}
    </div>
  );
}
